import { ReactNode } from 'react';
import solidLogo from '@/assets/solid-logo-darkbg.svg';
import { WaveBackground } from './WaveBackground';

interface WizardLayoutProps {
  children: ReactNode;
  currentStep: number;
  totalSteps: number;
  title?: string;
  hideChrome?: boolean;
}

export function WizardLayout({
  children,
  currentStep,
  totalSteps,
  title,
  hideChrome = false,
}: WizardLayoutProps) {
  const progressPercent = Math.min((currentStep / totalSteps) * 100, 100);

  return (
    <div className="bg-slate-900 min-h-screen flex flex-col items-center justify-center px-6 py-8 relative overflow-hidden">
      <WaveBackground />
      <div className="w-full max-w-2xl relative z-10">
        {/* Brand header */}
        {!hideChrome && (
          <div className="text-center mb-6">
            <img src={solidLogo} alt="Solid Digital" className="h-8 mx-auto" />
          </div>
        )}

        {/* Progress bar */}
        {!hideChrome && (
          <div className="mb-8">
            <div className="h-1 w-full rounded-full bg-slate-700 overflow-hidden">
              <div
                className="h-full rounded-full bg-accent-500 transition-all duration-500 ease-out"
                style={{ width: `${progressPercent}%` }}
              />
            </div>
          </div>
        )}

        {/* Content */}
        <main>
          {!hideChrome && title && (
            <h2 className="text-xl font-bold text-white mb-6 sm:text-2xl">
              {title}
            </h2>
          )}
          {children}
        </main>
      </div>

      {/* Footer */}
      {!hideChrome && (
        <footer className="mt-8 text-center relative z-10">
          <p className="text-sm text-slate-500">&copy; 2026 Solid Digital</p>
        </footer>
      )}
    </div>
  );
}
